export type Review = {
  role: string
  text: string
}

export const reviews: Review[] = [
  {
    role: 'Pastry Instructor · USA',
    text: 'Pastry Instructor Ready completely changed the way I prepare my classes. I used to spend hours organizing demonstrations and activities. Now I open the system, choose the lesson, and everything is already structured for me.',
  },
  {
    role: 'Baking Educator · Canada',
    text: 'The visual format is what I like most. My students understand techniques much faster when they can actually see the process, the common mistakes, and the correct result side by side.',
  },
  {
    role: 'Pastry Teacher · United Kingdom',
    text: 'The ready-to-teach classes save me so much time every week. My lessons feel more professional, better organized, and I feel much more confident walking into class.',
  },
  {
    role: 'Culinary Instructor · Australia',
    text: 'I used to spend hours preparing demonstrations and deciding what to teach next. Now I have a complete system that gives me structure from beginner to advanced.',
  },
  {
    role: 'Baking Instructor · Ireland',
    text: 'The bonus guides add a lot of value. Troubleshooting, assessments, class planning and teaching challenges are all things I can actually use with my students.',
  },
]
